import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { EmployeeOffboardingAppointmentHandling } from '@prisma/client';
import { OffboardingWizardValues } from '../../../../types/offboardings';
import { staggerSx } from '../../../../helpers/styles/offboardings';
import OptionItem from '../OptionItem';

function AppointmentsStep({ employeeName }: { employeeName: string }) {
  const { values, setFieldValue } = useFormikContext<OffboardingWizardValues>();
  return (
    <Stack
      gap={1.5}
      sx={staggerSx}
      role="radiogroup"
      aria-label="What happens to upcoming appointments?">
      <OptionItem
        selected={
          values.appointmentHandling ===
          EmployeeOffboardingAppointmentHandling.STAY_AT_SHOP
        }
        onClick={() =>
          setFieldValue(
            'appointmentHandling',
            EmployeeOffboardingAppointmentHandling.STAY_AT_SHOP,
          )
        }
        title="Stay at the shop"
        description={`${employeeName}'s upcoming appointments stay here as unassigned and can be picked up by another artist.`}
        aside="Default"
      />
      <OptionItem
        selected={
          values.appointmentHandling ===
          EmployeeOffboardingAppointmentHandling.TRANSFER_WITH_EMPLOYEE
        }
        onClick={() =>
          setFieldValue(
            'appointmentHandling',
            EmployeeOffboardingAppointmentHandling.TRANSFER_WITH_EMPLOYEE,
          )
        }
        title="Transfer with the artist"
        description={`Appointments follow ${employeeName} to whatever shop they land at next.`}
      />
    </Stack>
  );
}

export default AppointmentsStep;
